import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-[var(--color-light)] py-12 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8"
      >
        <h1 className="text-3xl font-bold text-[var(--color-text-dark)] mb-6">Datenschutzerklärung</h1>
        
        <div className="prose prose-lg max-w-none text-[var(--color-text-light)]">
          <p className="mb-4">
            Platzhalter für Datenschutzerklärung gemäß DSGVO.
          </p>
          
          <h2 className="text-xl font-semibold text-[var(--color-text-dark)] mt-8 mb-4">1. Verantwortlicher</h2>
          <p className="mb-4">
            [Name und Kontaktdaten des Verantwortlichen hier einfügen]
          </p>

          <h2 className="text-xl font-semibold text-[var(--color-text-dark)] mt-8 mb-4">2. Erhebung und Speicherung personenbezogener Daten</h2>
          <p className="mb-4">
            Wir erheben und verarbeiten folgende Daten: E-Mail-Adresse, Passwort (verschlüsselt), Nutzungsdaten.
          </p>

          <h2 className="text-xl font-semibold text-[var(--color-text-dark)] mt-8 mb-4">3. Cookies und Tracking</h2>
          <p className="mb-4">
            Diese Website verwendet Cookies für die Authentifizierung und Analyse. Sie können der Verwendung widersprechen.
          </p>

          <h2 className="text-xl font-semibold text-[var(--color-text-dark)] mt-8 mb-4">4. Ihre Rechte</h2>
          <p className="mb-4">
            Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Widerspruch gemäß DSGVO.
          </p>
        </div>

        <div className="mt-8 pt-6 border-t border-[var(--color-border)]">
          <Link to="/login" className="text-[var(--color-primary)] hover:underline">
            ← Zurück zur Anmeldung
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default Datenschutz;